import React, {forwardRef, useImperativeHandle} from "react";
import { useQueryClient } from 'react-query';
import __ from "lodash";

import useFindTariff from "../../../services/tariff/useFindTariff";

const TariffLookup = forwardRef((props, ref) => {

  const queryClient = useQueryClient();
  const params = __.pick(props, ['origin', 'destination', 'companyUuid', 'chargeCode', 'chargeDate', 'promotionCode', 'quantity', 'shcs', 'deck']);
  const updateRate = props.updateRate;

  const tariffRecord = useFindTariff({ queryClient, ...params, useCache: true});

  useImperativeHandle(ref, () => ({
    getTariffData () {
      return tariffRecord.data || {}
    }
  }));

  if (tariffRecord && tariffRecord.data && updateRate)
    updateRate(props.updateParams, tariffRecord.data);


  return ( <></> );
})

export default TariffLookup;